import request from "@/api/request"


export function listMessage(query) {
  return request({
    url: '/system/message/list',
    method: 'get',
    params: query
  })
}

export function getMyList(query) {
  return request({
    url: '/system/message/getMyList',
    method: 'get',
    params: query
  })
}
